import React, { useState } from "react";
import { fmtMSS } from "../../Utils/Helper";
export const Result = ({
  finalMessage,
  handleShare,
  downloadImageUrl,
  score,
  durations,
}) => {
  let lang = localStorage.getItem("lang");
  let greeting = "Excellent!!";
  let share_btn = "Share Result";
  let dowload_btn = "Download Certificate";

  if (lang === "hi") {
    share_btn = "रिजल्ट शेयर करें";
    dowload_btn = "सर्टिफिकेट डाउनलोड करें";
    greeting = "बधाई!!";
  }
  // const downloadCertificate = () =>{
  //     setIsLoading(true)
  //     setTimeout(() => {
  //         if(downloadImageUrl){
  //             window.open(downloadImageUrl, '_blank');
  //             setIsLoading(false)
  //         }else{
  //             setIsLoading(false)
  //         }
  //     }, 3000);
  // }
  return (
    <section class="quiz_padding result_bg">
      <div class="result_img">
        <h3>TOTAL TIME</h3>
        <button className="finalduartion">{fmtMSS(durations)}</button>
        <img src="/assets/images/cup.png" alt="" />
        <h4>{greeting || ""}</h4>
        <h5>{finalMessage || ""}</h5>
        <button
          type="button"
          class="share_result"
          onClick={() => handleShare()}
        >
          {share_btn}
        </button>
        <button type="button" className="dowload_cert">
          <a
            target="_blank"
            href={downloadImageUrl}
            style={{ color: "white", textDecoration: "none" }}
          >
            {dowload_btn}
          </a>
        </button>
      </div>
      <div
        id="divLoading"
        style={{ display: !downloadImageUrl ? "block" : "none" }}
      ></div>
    </section>
  );
};

// if(score <= 5){
//     greeting = "Better Luck Next Time!!";
// }else if(score <= 7){
//     greeting = "Great Effort!!";
// }else if(score <= 10){
//     greeting = "Excellent!!";
// }
// if (score <= 3) {
//     greeting = "अगली बार पुनः प्रयास करें!!";
// } else if (score <= 7) {
//     greeting = "तुमने अच्छी कोसिस की!!";
// } else if (score <= 10) {
//     greeting = "बधाई!!";
// }
